import React from "react"

import { IconProps } from "./IconProps"

const Icon: React.FC<IconProps> = ({
  color = "#000",
  scale = 1,
  strokeWidth = 1,
  ...svgProps
}) => (
  <svg
    width={24 * scale}
    height={24 * scale}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Shield"
    {...svgProps}
  >
    <path
      d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Icon
